module.exports = __webpack_public_path__ + "static/c-2-d93deb06be55fe02227487252c573913.jpg";